"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const formik_1 = require("formik");
const RenderButtonField = (props) => {
    const { field: { value, name, onChange, onBlur }, form: { touched, errors, setFieldValue }, label, inputValue, ...otherProps } = props;
    const error = (0, formik_1.getIn)(errors, name);
    const touch = (0, formik_1.getIn)(touched, name);
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement(Button_1.default, { name: name, variant: 'contained', color: 'primary', value: inputValue || '', onClick: () => setFieldValue(name, inputValue), ...otherProps }, label)));
};
RenderButtonField.propTypes = {
    field: prop_types_1.default.any.isRequired,
    form: prop_types_1.default.any.isRequired,
    label: prop_types_1.default.string.isRequired,
    inputValue: prop_types_1.default.string,
};
exports.default = RenderButtonField;
